// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"ba0d6240","421":"6fa53f11","576":"e600e10c","816":"270ad516","888":"19bf9fe9","920":"1b7c3ab3","952":"f005ca52","965":"cbe2db83"}[chunkId] + ".chunk.js";
};